import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Assessment from './components/Assessment';
import Results from './components/Results';
import AdminDashboard from './components/AdminDashboard';
import DatabaseTest from './components/DatabaseTest';
import './App.css';

function App() {
  const [assessmentData, setAssessmentData] = useState(null);

  const handleAssessmentComplete = (data) => {
    setAssessmentData(data);
  };

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-bg-primary via-bg-light to-primary-100">
        <main className="container mx-auto px-4 py-8">
          <AnimatePresence mode="wait">
            <Routes>
              <Route 
                path="/" 
                element={<Assessment onComplete={handleAssessmentComplete} />} 
              />
              <Route 
                path="/results" 
                element={
                  assessmentData ? (
                    <Results data={assessmentData} />
                  ) : (
                    <Navigate to="/" replace />
                  )
                } 
              />
              <Route 
                path="/admin" 
                element={<AdminDashboard />} 
              />
              <Route 
                path="/test" 
                element={<DatabaseTest />} 
              />
            </Routes>
          </AnimatePresence>
        </main>
      </div>
    </Router>
  );
}

export default App;